import { DefaultThemeOptions, FormsFeature } from "@ngt/forms";
import * as dtos from '@/api/dtos';
import logo from '@/assets/img/logo-small.png';
import { colors, responsiveFontSizes, ThemeOptions } from "@mui/material";

const primaryColorLight = '#502d77';
const secondaryColorLight = '#502d77';
const primaryColorDark = '#502d77';
const secondaryColorDark = '#a44b80';
const primaryColorMoreDark = '#584b66';
const secondaryColorMoreDark = '#502d77';

const formsFeature = new FormsFeature({
    dtos,
    baseRoute: '/research-member-form',
    extensions: [

    ],
    organisationOptions: {
        organisationName: 'Breast Cancer Trials',
        organisationLogo: logo
    },
    client: {
        baseUrl: import.meta.env.VITE_API_URL,
        basePath: '/api',
        client: undefined
    },
    themeOptions: {
        beforeThemeCreated: (themeOptions, chosenTheme) => {
            const newOptions: ThemeOptions = {
                ...themeOptions,
                palette: {
                    ...themeOptions.palette,
                    primary: {
                        main: chosenTheme === 'dark' ? primaryColorDark : primaryColorLight
                    },
                    secondary: {
                        main: chosenTheme === 'dark' ? secondaryColorMoreDark : secondaryColorLight 
                    }
                },
                components: {
                    MuiOutlinedInput: {
                        styleOverrides: {
                            // root: {
                            //     borderRadius: 50
                            // }
                        }
                    },
                    MuiToggleButtonGroup: {
                        // defaultProps: {
                        //     color: "primary"
                        // },
                        styleOverrides: {
                            root: {
                                "& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected": {backgroundColor: "#502d77", color: "white"}
                            }
                        }
                    },
                    MuiFormControlLabel:{
                        styleOverrides: {
                            root: {
                                "& #full": {fontSize: "3rem"},
                            }
                        }
                    },
                    MuiSvgIcon: {
                        styleOverrides:{
                            root:{
                                "&.MuiSvgIcon-fontSizeMedium.MuiStepIcon-root": {color: "#502d77"},
                                "&.MuiSvgIcon-fontSizeMedium.MuiStepIcon-root.Mui-active": {color: "#EC008C"}
                            }
                        }
                    },
                    MuiStepLabel:{
                        styleOverrides: {
                            root: {
                                "& .MuiStepLabel-label": {color: "#502d77"},
                                "& .MuiStepLabel-label.Mui-completed": {color: "#502d77"},
                                "& .MuiStepLabel-label.Mui-active": {fontSize: "1.2rem", color: "#EC008C"}
                            }
                        }
                    }
                }
            };

            if (chosenTheme !== 'dark' && newOptions.palette) {
                newOptions.palette.background = {
                    default: '#ffffff'
                }
            }
            
            return newOptions;
        },
        afterThemeCreated: (theme, chosenTheme) => {
            return responsiveFontSizes(theme as any) as any;
        },
        themeOptions: DefaultThemeOptions
    },
    initialAuthentication: (window as any).AUTH,
    initialFormMetadata: (window as any).FORM_METADATA, 
    initialMetadataTypes: (window as any).METADATA_TYPES,
    disableAuthentication: true
});

export default formsFeature;